import React, { Fragment } from "react";

const NotFound = () => {
  return (
    <Fragment>
      <h1>404</h1>
    </Fragment>
  );
};

export default NotFound;
